import React, { JSX } from 'react';
import { useProfile } from '../context/ProfileContext';
import Load from './Load';

interface Props {
  children: JSX.Element;
}

const ProfileGate: React.FC<Props> = ({ children }) => {
  const { isLoading } = useProfile();

  if (isLoading) {
    return <Load />;
  }

  return children;
};

export default ProfileGate;

